module.exports = __webpack_public_path__ + "img/mercadoPago.5fba9f22.png";